import React from "react";
import { colors } from "@utils/styles";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Title from "components/Reusables/Title";
import Accordion from "react-bootstrap/Accordion";
import Text from "@components/Reusables/Text";
export default function ConferenceScheduleAtGlance() {
	const conferenceData = {
		// "Thursday, 4/11/2024": [
		// 	{ type: "general", name: "Morning Preconference Courses*", time: "8:00 AM - 12:00 PM" },
		// 	{ type: "general", name: "Afternoon Preconference Courses*", time: "1:00 PM - 5:00 PM" },
		// 	{ type: "general", name: "All day Preconference Courses*", time: "8:00 AM - 5:00 PM" },
		// 	{ type: "", name: "", time: "" },
		// 	{ type: "", name: "", time: "" },
		// 	{ type: "", name: "", time: "" },
		// 	{ type: "", name: "", time: "" },
		// 	{ type: "", name: "", time: "" },
		// 	{ type: "", name: "", time: "" },
		// 	{ type: "", name: "", time: "" },
		// ],
		"Thursday, 4/11/2024": [
			{ type: "session", time: "12:00 PM - 5:00 PM", name: "Building Bridges with Payors" },
			{ type: "session", time: "12:00 PM - 5:00 PM", name: "Physician Enterprise: Return on Investment" },
			{ type: "session", time: "12:00 PM - 5:00 PM", name: "Revenue Cycle Check Up" },
		],
		"Friday, 4/12/2024": [
			{ type: "wellness", time: "6:30 AM - 7:30 AM", name: "Wellness Activity" },
			{ type: "breakfast", time: "7:30 AM - 8:30 AM", name: "Breakfast" },
			{ type: "general", time: "8:30 AM - 10:00 AM", name: "Welcome & Opening Keynote" },
			{ type: "breakfast", time: "10:00 AM - 10:30 AM", name: "Networking Break in Exhibit Hall" },
			{ type: "session", time: "10:30 AM - 11:30 AM", name: "Concurrent Breakout Sessions" },
			{ type: "breakfast", time: "11:30 AM - 1:00 PM", name: "Lunch /Exhibit Time" },
			{ type: "general", time: "1:00 PM - 2:00 PM", name: "General Session" },
			{ type: "breakfast", time: "2:00 PM - 2:15 PM", name: "Transition" },
			{ type: "session", time: "2:15 PM - 3:15 PM", name: "Concurrent Breakout Sessions" },
			{ type: "breakfast", time: "3:15 PM - 3:30 PM", name: "Transition" },
			{ type: "session", time: "3:30 PM - 4:30 PM", name: "Concurrent Breakout Sessions" },
			{ type: "breakfast", time: "4:30 PM - 4:45 PM", name: "Transition" },
			{ type: "general", time: "4:45 PM - 6 PM", name: "CPE Convocation & Awards" },
			{ type: "optional", time: "6 PM to 7:30 PM", name: "Welcome Reception in Exhibit Hall" },
			{ type: "breakfast", time: "7:30 PM", name: "Sponsor Dinners" },
		],
		"Saturday, 4/13/2024": [
			{ time: "6:30 AM - 7:30 AM", type: "wellness", name: "Wellness Activity" },
			{ time: "7:30 AM - 8:30 AM", type: "breakfast", name: "Breakfast" },
			{ time: "8:30 AM - 9:30 AM", type: "general", name: "General Session" },
			{ time: "9:30 AM - 10:00 AM", type: "breakfast", name: "Networking Break in Exhibit Hall" },
			{ time: "10:00 AM - 11:00 AM", type: "session", name: "Concurrent Breakout Sessions" },
			{ time: "11:00 AM - 11:15 AM", type: "breakfast", name: "Transition" },
			{ time: "11:15 AM - 12:15 PM", type: "general", name: "Concurrent Breakout Sessions or Sponsored Session" },
			{ time: "12:15 PM - 1:30 PM", type: "breakfast", name: "Lunch/Exhibit Time" },
			{ time: "1:30 PM - 2:30 PM", type: "session", name: "Concurrent Breakout Sessions " },
			{ time: "2:30 PM - 2:45 PM", type: "breakfast", name: "Transition" },
			{ time: "2:45 PM - 4:00 PM", type: "session", name: "Communities of Practice" },
			{ time: "4:00 PM - 4:15 PM", type: "breakfast", name: "Transition" },
			{ time: "4:30 PM - 5:30 PM", type: "general", name: "General Session" },
			{ time: "5:30 PM to", type: "optional", name: "Social Event" },
			{ time: "6:30 PM", type: "breakfast", name: "Sponsor Dinners" },
		],

		"Sunday, 4/14/2024": [
			{ time: "6:30 AM - 7:30 AM", name: "Wellness Activity", type: "wellness" },
			{ time: "7:30 AM - 8:30 AM", name: "Breakfast", type: "breakfast" },
			{ time: "8:30 AM - 9:15 AM", name: "Panel / Communities of Practice", type: "general" },
			{ time: "9:30 AM - 9:45 AM", name: "Session 1", type: "session" },
			{ time: "9:50 AM - 10:05 AM", name: "Session 2", type: "session" },
			{ time: "10:10 AM - 10:25 AM", name: "Session 3", type: "session" },
			{ time: "10:25 AM - 10:55 AM", name: "Coffee & Networking Break", type: "breakfast" },
			{ time: "11:00 AM - 11:15 AM", name: "Session 4", type: "session" },
			{ time: "11:20 AM - 11:35 AM", name: "Session 5", type: "session" },
			{ time: "11:40 AM - 11:55 AM", name: "Session 6", type: "session" },
			{ time: "", name: "", type: "" },
			{ time: "", name: "", type: "" },
			{ time: "", name: "", type: "" },
			{ time: "", name: "", type: "" },
			{ time: "", name: "", type: "" },
		],
	};

	const capstoneData = {
		"Thursday, 4/11/2024": [
			{ type: "breakfast", name: "Breakfast, Badge Pickup", time: "7:00 AM - 8:00 AM" },
			{ type: "general", name: "Capstone General Session", time: "8:00 AM - 10:30 AM" },
			{ type: "breakfast", name: "Break  ", time: "10:30 AM - 10:40 AM" },
			{ type: "session", name: "Breakout Sessions", time: "10:40 AM - 12:30 PM " },
			{ type: "breakfast", name: "Lunch", time: "12:30 PM - 1:30 PM " },
			{ type: "general", name: "Capstone General Session", time: "1:30 PM - 3:30 PM" },
			{ type: "breakfast", name: "Break", time: "3:30 PM - 3:45 PM " },
			{ type: "session", name: "Breakout Sessions ", time: "3:45 PM - 5:30 PM" },
		],
		"Friday, 4/12/2024": [
			{ type: "general", name: "Capstone General Session", time: "7:00 AM - 7:30 AM" },
			{ type: "breakfast", name: "Breakfast", time: "7:30 AM - 8:30 AM " },
			{ type: "general", name: "Conference Opening Keynote", time: "8:30 AM - 10:00 AM" },
			{ type: "breakfast", name: "Break  ", time: "10:00 AM - 10:10 AM " },
			{ type: "general", name: "Capstone General Session", time: "10:10 AM - 11:25 AM" },
			{ type: "breakfast", name: "Lunch", time: "11:25 AM - 12:10 PM" },
			{ type: "session", name: "Breakout Sessions", time: "12:10 PM - 1:55 PM" },
			{ type: "breakfast", name: "Break  ", time: "1:55 PM - 2:05 PM" },
			{ type: "general", name: "Capstone General Session", time: "2:05 PM - 3:20 PM" },
			{ type: "breakfast", name: "Break", time: "3:20 PM - 3:30 PM" },
			{ type: "session", name: "Breakout Sessions ", time: "3:30 PM - 4:35 PM " },
			{ type: "breakfast", name: "Break", time: "4:35 PM - 4:45 PM" },
			{ type: "optional", name: "CPE Convocation", time: "4:45 PM - 6 PM" },
			{ type: "general", name: "Conference Welcome Reception", time: "6 PM to 7:30 PM" },
		],
		"Saturday, 4/13/2024": [
			{ type: "breakfast", name: "Breakfast", time: "7:30 AM - 8:30 AM" },
			{ type: "general", name: "Conference Opening Keynote", time: "8:30 AM - 9:30 AM" },
			{ type: "breakfast", name: "Break  ", time: "9:30 AM - 9:40 AM" },
			{ type: "general", name: "Capstone General Session", time: "9:40 AM - 12:30 PM " },
			{ type: "breakfast", name: "Lunch", time: "12:30 PM - 1:15 PM" },
			{ type: "session", name: "Breakout Sessions", time: "1:15 PM - 2:35 PM" },
			{ type: "breakfast", name: "Break", time: "2:35 PM - 2:45 PM" },
			{ type: "session", name: "Breakout Sessions ", time: "2:45 PM - 4:15 PM" },
			{ type: "breakfast", name: "Break", time: "4:15 PM - 4:30 PM" },
			{ type: "general", name: "Conference General Session", time: "4:30 PM - 5:30 PM " },
			{ type: "optional", name: "Social Event", time: "5:30 PM to" },
		],
		"Sunday, 4/14/2024": [
			{ type: "breakfast", name: "Breakfast", time: "6:30 AM - 7:30 AM" },
			{ type: "session", name: "Capstone Final Presentations", time: "7:00 AM - 9:00 AM" },
		],
	};

	const vanguardData = {
		"Friday, 4/12/2024": [
			{ type: "breakfast", name: "Breakfast ", time: "7:30 AM - 8:30 AM" },
			{ type: "general", name: "Conference General Session", time: "8:30 AM - 10:00 AM" },
			{ type: "breakfast", name: "Break", time: "10:00 AM - 10:15 AM" },
			{ type: "general", name: "Vanguard Welcome", time: "10:15 AM - 10:30 AM" },
			{ type: "session", name: "Session 1: ", time: "10:30 AM - 11:30 AM " },
			{ type: "breakfast", name: "Lunch  ", time: "11:30 AM - 1:00 PM " },
			{ type: "session", name: "Session 2: ", time: "1:00 PM - 2:00 PM" },
			{ type: "breakfast", name: "Break", time: "2:00 PM - 2:15 PM" },
			{ type: "session", name: "Session 3: ", time: "2:15 PM - 3:15 PM" },
			{ type: "session", name: "Session 4: ", time: "3:15 PM - 4:15 PM" },
			{ type: "general", name: "Closing Comments", time: "4:15 PM - 4:30 PM" },
			{ type: "breakfast", name: "Break", time: "4:30 PM - 4:45 PM" },
			{ type: "general", name: "CPE Convocation & Awards", time: "4:45 PM - 6 PM " },
			{ type: "optional", name: "Welcome Reception in Exhibit Hall", time: "6 PM to 7:30 PM" },
		],
	};
	const ScheduleAccordion = (props) => {
		const { className, scheduleData, title } = props;
		return (
			<Accordion className={`${className}`}>
				<Accordion.Item className={``} eventKey={"main"} key={"main"}>
					<Accordion.Header className={``}>
						<Row className=" align-items-end w-100 ">
							<Col className="" xs={"auto"}>
								<Title className="mb-0 text-center" color={colors.white} text={title} element="h3" />
							</Col>
						</Row>
					</Accordion.Header>
					<Accordion.Body>
						<Row className="ms-4 g-0">
							{Object.keys(scheduleData).map((date) => {
								return (
									<Col
										className="d-flex flex-column"
										md={Object.keys(scheduleData).length > 3 ? 3 : 4}
										sm={12}
									>
										<Row className="g-0">
											<div className="box table-header fw-bold text-center">{date}</div>
										</Row>
										{scheduleData[date].map((session) => {
											return (
												<ScheduleRow
													time={session.time}
													className={session.type}
													activity={session.name}
												/>
											);
										})}
									</Col>
								);
							})}
						</Row>
					</Accordion.Body>
				</Accordion.Item>
			</Accordion>
		);
	};
	return (
		<Container id="schedule-at-a-glance" fluid className="container-lg mt-5">
			<Title text="Schedule-at-a-Glance" element="h2" />
			<Row className="g-0">
				<Text
					decoration="italic"
					size="13"
					text="*Preconference courses will be available Thursday, April 11."
				/>
				<Text decoration="italic" size="13" text="*Times subject to change. Check back for details." />
				<ScheduleAccordion
					className="conf-schedule"
					title={"Conference Schedule"}
					scheduleData={conferenceData}
				/>
				{/* <ScheduleAccordion
					className="capstone-schedule"
					title={"Capstone Schedule"}
					scheduleData={capstoneData}
				/> */}
				<ScheduleAccordion
					className="vanguard-schedule"
					title={"Vanguard Schedule"}
					scheduleData={vanguardData}
				/>
			</Row>

			<style global jsx>{`
				.vanguard-schedule .accordion-item,
				.capstone-schedule .accordion-item,
				.conf-schedule .accordion-item {
					border: none;
					background: none;
				}

				.conf-schedule .accordion-body {
					background: ${colors.white};
				}

				.vanguard-schedule .accordion-button::after,
				.capstone-schedule .accordion-button::after,
				.conf-schedule .accordion-button::after {
					background-image: ${`url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='${encodeURIComponent(
						colors.white
					)}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>")`};
				}

				.vanguard-schedule .accordion-button,
				.capstone-schedule .accordion-button,
				.conf-schedule .accordion-button {
					margin-bottom: 1em;
					background: ${colors.lightBlue};
					transition: all 0.5s;
					color: ${colors.white};
					font-weight: bold;
					padding: 5px;
				}

				.capstone-schedule .accordion-button {
					background: ${colors.yellow};
				}
				.vanguard-schedule .accordion-button {
					background: ${colors.red};
				}
			`}</style>

			<style jsx>{`
				.box {
					border: 1px solid black;
					padding: 1em 2em;
				}
				@media screen and (max-width: 992px) {
					.box {
						padding: 0.5em 1em;
					}
				}
				.table-header {
					font-weight: bold;
					font-size: 20px;
					text-align: center;
				}
			`}</style>
		</Container>
	);
}

const ScheduleRow = (props) => {
	return (
		<>
			<Row className="g-0 h-100">
				<Col className="" xs={6}>
					<div className={`box ${!props.time ? "d-none d-md-block light-border" : ""}`}>{props.time}</div>
				</Col>
				<Col xs={6}>
					<div
						className={`${props.className} box  ${!props.activity ? "d-none d-md-block light-border" : ""}`}
					>
						{props.activity}
					</div>
				</Col>
			</Row>
			<style jsx>{`
				.box {
					border: 1px solid black;
					padding: 0.2em 0.2em;
					display: flex;
					justify-content: center;
					align-items: center;
					height: 100%;
					min-height: 80px;
					font-weight: bold;
				}
				@media screen and (max-width: 992px) {
					.box {
						padding: 0.5em 1em;
					}
				}
				.box.light-border {
					border: none;
				}

				.wellness {
					background: ${colors["yellow"]};
					filter: brightness(130%);
				}
				.breakfast {
					background: ${colors.darkGray};
					filter: brightness(105%);
				}
				.general {
					background: ${colors.green};
					filter: brightness(140%);
				}
				.session {
					background: ${colors.blue};
					filter: brightness(140%);
				}

				.development-day {
					background: ${colors.greyBlue};
					filter: brightness(150%);
				}
				.networking-Break {
					background: ${colors.lightGray};
				}

				.optional {
					background: ${colors.red};
				}
			`}</style>
		</>
	);
};
